
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import "@/store/modules/forms/form9";
const form9State = namespace("Form9");

import Form9ProcessHeader from "@/components/process/Form9/components/Form9ProcessHeader.vue";
import Form9 from "@/components/process/Form9/components/pdf/Form9.vue"

import { form9StatusInfoType } from '@/types/Information/Form9';

@Component({
    components:{
        Form9ProcessHeader,
        Form9
    }
})
export default class PreviewForm9 extends Vue {

    @form9State.State
    public currentRequisitionId: string;

    stepsCompleted = {} as form9StatusInfoType; 
    
    dataReady = false;
    pdfReady = false;

    mounted() {
        this.dataReady = false;         
        this.stepsCompleted = {
            first: true,
            second: false,
            third: false
        }
        this.dataReady = true;       
    }

    public navigateToSubmitPage() {
        this.$router.push({name: "proceed-form9"}); 
    }
}
